import React from "react";
import {
  Button,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Snackbar,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import parsePhoneNumber from "libphonenumber-js";
import { useTranslation } from "react-i18next";
import { updatePhone } from "../../../utilities/authFlow";

import request from "../../../utilities/requests";
// List of all international phone country codes
const COUNTRY_CODES = [
  "+1","+7","+20","+27","+30","+31","+32","+33","+34","+36","+39","+40",
  "+41","+43","+44","+45","+46","+47","+48","+49","+51","+52","+53","+54",
  "+55","+56","+57","+58","+60","+61","+62","+63","+64","+65","+66","+81",
  "+82","+84","+86","+90","+91","+92","+93","+94","+95","+98","+211","+212",
  "+213","+216","+218","+220","+221","+222","+223","+224","+225","+226",
  "+227","+228","+229","+230","+231","+232","+233","+234","+235","+236",
  "+237","+238","+239","+240","+241","+242","+243","+244","+245","+246",
  "+247","+248","+249","+250","+251","+252","+253","+254","+255","+256",
  "+257","+258","+260","+261","+262","+263","+264","+265","+266","+267",
  "+268","+269","+290","+291","+297","+298","+299","+350","+351","+352",
  "+353","+354","+355","+356","+357","+358","+359","+370","+371","+372",
  "+373","+374","+375","+376","+377","+378","+379","+380","+381","+382",
  "+383","+385","+386","+387","+389","+420","+421","+423","+500","+501",
  "+502","+503","+504","+505","+506","+507","+508","+509","+590","+591",
  "+592","+593","+594","+595","+596","+597","+598","+599","+670","+672",
  "+673","+674","+675","+676","+677","+678","+679","+680","+681","+682",
  "+683","+685","+686","+687","+688","+689","+690","+691","+692","+850",
  "+852","+853","+855","+856","+870","+871","+872","+873","+874","+875",
  "+876","+877","+878","+879","+880","+881","+882","+883","+886","+960",
  "+961","+962","+963","+964","+965","+966","+967","+968","+970","+971",
  "+972","+973","+974","+975","+976","+977","+992","+993","+994","+995",
  "+996","+998"
];

const EditPhone = ({ open, close, success }) => {
  const { t } = useTranslation();
  const [phone, setPhone] = React.useState("");
  const [countryCode, setCountryCode] = React.useState("+1");
  const [error, setError] = React.useState("");


  const validatePhone = () => {
    console.log("validating phone");
    if (!phone) {
      setError(true);
      return false;
    }
    const phoneNumber = parsePhoneNumber(`${countryCode}${phone}`);
    if (!phoneNumber || !phoneNumber.isValid()) {
      console.log("Invalid phone");
      setError(true);
      return false;
    }
    if (phoneNumber.isValid() && error) {
      setError(null);
    }
    return true;
  };

  const handleUpdate = async () => {
    //if code is not showing, first validate change the email
    if (!validatePhone(phone)) {
      return;
    }
    const phoneNumber = parsePhoneNumber(`${countryCode}${phone}`);
    const aResult = await updatePhone(phoneNumber.number);
    if (!aResult.success) {
      alert(aResult.error);
      return
    }
    let bResult = await request("profile/update", "post", { phone: phoneNumber.number });
    if (!bResult.success) {
      alert(bResult.error);
      return
    }
    success("Phone");
    setPhone("");
    return;
  };



  const handleClose = () => {
    close();
    setError(null)
  };

  return (
    <Dialog open={open} onClose={close}>
      <DialogTitle>{t('profile.editphonedialog.title')}</DialogTitle>
      <DialogContent>
        <DialogContentText>{t('profile.editphonedialog.content')}</DialogContentText>
        <div style={{ display: "flex", gap: "8px", marginTop: "16px" }}>
          <FormControl variant="standard" style={{marginTop: 8}}>
            <InputLabel id="edit-phone-code-label">Code</InputLabel>
            <Select
              labelId="edit-phone-code-label"
              label="Code"
              value={countryCode}
              onChange={(e) => setCountryCode(e.target.value)}
            >
              {COUNTRY_CODES.map((code) => (
                <MenuItem key={code} value={code}>
                  {code}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            autoFocus
            margin="dense"
            id="phone"
            label={t('profile.editphonedialog.label')}
            variant="standard"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            onBlur={validatePhone}
            error={Boolean(error)}
            helperText={error ? "Please enter a valid phone number" : ""}
            placeholder="1234567890"
            inputProps={{ inputMode: 'numeric' }}
            style={{ flex: 1 }}
          />
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>{t('dialog.cancel.button')}</Button>
        <Button onClick={handleUpdate}>{t('dialog.update.button')}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditPhone;
